"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.number.constructor.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _report = require("@/config/report");

var _vuex = require("vuex");

var _project = require("@/api/project");

var _report2 = require("@/api/report");

var _navItem = _interopRequireDefault(require("./navItem.vue"));

var _variables2 = _interopRequireDefault(require("@/styles/variables.scss"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ReportNav',
  components: {
    NavItem: _navItem.default
  },
  data: function data() {
    return {
      reportNavList: _report.reportNavList,
      projectId: '',
      reportId: '',
      projectInfo: {
        game_name: ''
      },
      reportNavMap: {},
      reportInfo: {
        inform_name: ''
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['vipLevel', 'isVip', 'sidebar'])), {}, {
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
          name = route.name; // if set path, the sidebar will highlight the path you set

      if (meta.activeMenu) {
        return meta.activeMenu;
      }

      return name;
    }
  }),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var reportNav, i, item, projectRes, informRes;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reportNav = [].concat(_report.reportNavList, _report.excludeReportNavList);

              for (i = 0; i < reportNav.length; i++) {
                item = reportNav[i];
                _this.reportNavMap[item.name] = item;
              }

              _this.projectId = Number(_this.$route.params.projectId);
              _this.reportId = Number(_this.$route.params.reportId);
              _context.next = 6;
              return (0, _project.projectInfo)({
                game_id: _this.projectId
              });

            case 6:
              projectRes = _context.sent;
              _this.projectInfo = projectRes.data.data;

              _this.$store.dispatch('report/restoreDevice', {
                reportDevice: 1
              });

              _context.next = 11;
              return (0, _report2.informInfo)({
                inform_id: _this.reportId
              });

            case 11:
              informRes = _context.sent;
              _this.reportInfo = informRes.data.data;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    checkVipAllow: function checkVipAllow(itemVipLevel) {
      return this.isVip && this.vipLevel >= itemVipLevel;
    },
    gotoPage: function gotoPage(item) {
      // console.log({ name: item.name, params: { projectId: this.projectId, reportId: this.reportId }})
      this.$router.push({
        name: item.name,
        params: {
          projectId: this.projectId,
          reportId: this.reportId
        }
      });
    },
    variables: function variables() {
      return _variables2.default;
    },
    goBack: function goBack() {
      this.$router.push({
        name: 'ProjectIndex',
        params: {
          id: this.projectId
        }
      });
    }
  }
};
exports.default = _default;